/**
 * Do not edit this file it is auto-generated by io-utils / gen-api-models.
 * See https://github.com/pagopa/io-utils
 */
/* eslint-disable  */

import * as t from "io-ts";

/**
 * The script that can be executed by Mocker and that permits to generate dynamic values based on scripted execution.
 */

// required attributes
const ScriptMetadataR = t.interface({
  description: t.string,

  input_parameters: t.readonlyArray(t.string, "array of string"),

  name: t.string,

  output_parameters: t.readonlyArray(t.string, "array of string")
});

// optional attributes
const ScriptMetadataO = t.partial({
  id: t.string
});

export const ScriptMetadata = t.intersection(
  [ScriptMetadataR, ScriptMetadataO],
  "ScriptMetadata"
);

export type ScriptMetadata = t.TypeOf<typeof ScriptMetadata>;
